import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import IndexPage from 'front/pages/IndexPage/IndexPage.js'
import ProjectListPage from 'front/pages/ProjectListPage/ProjectListPage.js'
import ProjectPage from 'front/pages/ProjectPage/ProjectPage.js'
import ContactsPage from 'front/pages/ContactsPage/ContactsPage.js'
import AboutPage from 'front/pages/AboutPage/AboutPage.js'

const LANGS = ['en'].join('|')

module.exports = Backbone.Router.extend({
    routes: {},

    initialize () {
        this.route(new RegExp(`^(${LANGS}/)?/?(\\?.+)?$`), 'index')
        this.route(new RegExp(`^(${LANGS}/)?work/(\\?.+)?$`), 'projectList')
        this.route(new RegExp(`^(${LANGS}/)?work/(\\d+)/(\\?.+)?$`), 'project')
        this.route(new RegExp(`^(${LANGS}/)?contacts/(\\?.+)?$`), 'contacts')
        this.route(new RegExp(`^(${LANGS}/)?about/(\\?.+)?$`), 'about')
    },

    start () {
        this.view = null

        let pushStateSupported = history && _.isFunction(history.pushState)
        Backbone.history.start({pushState: pushStateSupported})
    },

    index () {
        this.activate(IndexPage)
    },

    projectList () {
        this.activate(ProjectListPage)
    },

    project (lang, id) {
        this.activate(ProjectPage, id)
    },

    contacts () {
        this.activate(ContactsPage)
    },

    about () {
        this.activate(AboutPage)
    },

    activate (view) {
        if (!this.view) {
            this.view = new view({
                arguments: Array.prototype.slice.call(arguments, 1)[0],
                prerendered: true
            })
        } else {
            if (this.view.type !== view.prototype.type) {
                let promise = this.view.deactivate()

                this.view = new view({
                    promise,
                    arguments: Array.prototype.slice.call(arguments, 1)[0]
                })
            }
        }

        //this.view.activate()
    }
})



// WEBPACK FOOTER //
// ./assets/app/front/Router.js